import RackMacro from "effects/RackMacro.js";
import {index} from 'parameters/ParameterIndex.js';

export default superclass => class extends superclass {
    macros = [];

    createMacro(params) {
        let ratios = [];
        let min = 10000000;
        let minParam = undefined;
        for (let param of params) {
            let ratio = (param.get(true) - param.min) / (param.max - param.min);
            if (ratio < min) {
                min = ratio;
                minParam = param;
            }
            ratios[param.id] = ratio;
        }

        let macroValue = Math.max(0.00001, min);

        // macro
        let macro = new RackMacro(
            'macro +' + params.length,
            this.sequencerEngine,
            this.context,
            false,
            macroValue);

        // macro will go from 0-1 at 0 you want the parameter
        // to be where it currently is. at 1 it should be at its max
        for (let p of params) {
            if (p === minParam) {
                macro.addParameter(p);
            } else {
                let max = (p.get(true) + p.min*(macroValue-1))/macroValue;
                let p_name = p.name.toLowerCase();
                if (["level", "gain", "volume"].some(
                    n => p_name.includes(n))) {
                    max = p.max;
                }
                macro.addParameter(p, p.min, max);
            }
        }

        this.macros.push(macro);
        this.setParameter(macro.macroParameter);
        return macro;
    }

    loadMacrosJson(json) {
        let parameters = [];
        for (let module of this.modules) {
            parameters = [... parameters, ... module.getAllParameters()];
            for (let lfo of module.lfos) {
                parameters = [... parameters, ...lfo.lfo.parameters];
            }
            for (let env of module.envelopes) {
                parameters = [... parameters, ...env.parameters];
            }
            for (let track of module.tracks) {
                parameters = [... parameters, ...track.getAllParameters()];
            }
        }
        for (let _macro of json) {
            let macro = new RackMacro(
                _macro.name, this.sequencerEngine, this.context, false);
            macro.fromJson(_macro, parameters);
            this.macros.push(macro);
        }
    }
}
